<template>
  <v-app id='app'>
    <router-view/>
  </v-app>
</template>

<script>
/* global FB */
import { store } from '@/store/store'
export default {
  name: 'App',
  store,
  created () {
    window.fbAsyncInit = (function () {
      FB.init({
        appId: process.env.VUE_APP_FACEBOOK_APP_ID,
        cookie: true,
        xfbml: true,
        version: 'v3.2'
      })
    })(function (d, s, id) {
      if (d.getElementById(id)) { return }
      let js = d.createElement(s)
      js.id = id
      js.async = true
      js.src = 'https://connect.facebook.net/en_US/sdk.js'

      let fjs = d.getElementsByTagName(s)[0]
      fjs.parentNode.insertBefore(js, fjs)
    }(document, 'script', 'facebook-jssdk'))
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', 'Roboto', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.theme--light.v-card {
  background-color: #ffffff
}
.theme--light.v-list {
  background-color: #fafafa
}

.v-btn {
  text-transform: none !important
}
</style>
